import { CheckboxItem } from "../../../common/checkboxItem/CheckboxItem";
import { useState } from "react";
import { FREYA_SCANNING_MODE_STORAGE_KEY } from "../../../../common/constants";
import { FreyaScanningMode } from "../../../../common/enums";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FreyaPrintSettingsScannerSelector } from "../FreyaPrintSettingsScannerSelector";

export const ScannerCheckbox = () => {
  const { t } = useTranslation("common");
  const [isScannerChecked, setScannerChecked] = useState(
    localStorage.getItem(FREYA_SCANNING_MODE_STORAGE_KEY) === FreyaScanningMode.SCANNER
  );

  const handleScannerChange = () => {
    const isScannerModeSelected = !isScannerChecked;
    setScannerChecked(isScannerModeSelected);

    const newCacheValue = isScannerModeSelected ? FreyaScanningMode.SCANNER : FreyaScanningMode.CAMERA;
    localStorage.setItem(FREYA_SCANNING_MODE_STORAGE_KEY, newCacheValue);
  };

  return (
    <Box sx={{ marginBottom: "20px" }}>
      <CheckboxItem label={t("freya.enableLaserScanner")} checked={isScannerChecked} onChange={handleScannerChange} />
      {isScannerChecked && <FreyaPrintSettingsScannerSelector isScannerChecked={isScannerChecked} />}
    </Box>
  );
};
